import { useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAPS_API_KEY, hasGoogleMapsKey } from '../config/maps';

const LOADER_ID = 'mytownly-google-maps';
const MAP_LIBRARIES = ['places'];

/** Shared Google Maps script loader — call once at app root to preload. */
export function useGoogleMapsLoader() {
  const enabled = hasGoogleMapsKey();
  const state = useJsApiLoader({
    id: LOADER_ID,
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: MAP_LIBRARIES,
    preventGoogleFontsLoading: true,
  });

  if (!enabled) {
    return { isLoaded: true, loadError: undefined, usesGoogle: false };
  }

  return { ...state, usesGoogle: true };
}

/** Invisible component — mount at app root to warm the Maps script. */
export function GoogleMapsPreloader() {
  useGoogleMapsLoader();
  return null;
}
